import React from "react";

// Dashboard
const InventoryDashboard = React.lazy(() => import("../../Inventory/InventoryERPDashboard"));

// Projects
const ProjectTable = React.lazy(() => import("../../Inventory/Projects/Project/ProjectTable"));
const ProjectForm = React.lazy(() => import("../../Inventory/Projects/Project/ProjectForm"));
const SectionForm = React.lazy(() => import("../../Inventory/Projects/Section/SectionForm"));
const SectionTable = React.lazy(() => import("../../Inventory/Projects/Section/SectionTable"));

// Units
const Unit = React.lazy(() => import("../../Inventory/Projects/Units/Unit"));
const UnitTable = React.lazy(() => import("../../Inventory/Projects/Units/UnitTable"));

// New Purchase
const NewPurchaseTable = React.lazy(
  () => import("../../Inventory/Projects/NewPurchase/NewPurchaseTable"),
);
const NewPurchaseForm = React.lazy(
  () => import("../../Inventory/Projects/NewPurchase/NewPurchase"),
);

// Re-Purchase
const RePurchase = React.lazy(() => import("../../Inventory/Projects/RePurchase/RePurchase"));
const RePurchaseTable = React.lazy(
  () => import("../../Inventory/Projects/RePurchase/RePurchaseTable"),
);

// Print Templates
const MainPrintTemplates = React.lazy(
  () => import("../../Inventory/Projects/PrintTemplates/MainPrintTemplates"),
);
const PrintTemplate = React.lazy(
  () => import("../../Inventory/Projects/PrintTemplates/PrintTemplate"),
);

// Deals - Deal Bought
const DealBoughtTable = React.lazy(
  () => import("../../Inventory/deals/DealBought/DealBoughtTable"),
);
const DealBought = React.lazy(() => import("../../Inventory/deals/DealBought/DealBought"));

// Deals - Deal Sold
const DealSoldMain = React.lazy(() => import("../../Inventory/deals/DealSold/MainDealSold"));

// Deals - Sellers
const SellerForm = React.lazy(() => import("../../Inventory/LandAndSeller/Seller/SellerForm"));
const SellerTable = React.lazy(() => import("../../Inventory/LandAndSeller/Seller/SellerTable"));

// Availability
const AvailabilityComp2 = React.lazy(() => import("../../Inventory/Availability/Availability"));
const BookingUnits = React.lazy(() => import("../../Inventory/Availability/BookedUnits"));

// Land Deals
const LandDealTable = React.lazy(
  () => import("../../Inventory/LandAndSeller/LandDeals/LandDealTable"),
);
const LandDealForm = React.lazy(
  () => import("../../Inventory/LandAndSeller/LandDeals/LandDealForm"),
);

// Land
const LandTable = React.lazy(() => import("../../Inventory/LandAndSeller/Land/LandTable"));
const LandForm = React.lazy(() => import("../../Inventory/LandAndSeller/Land/LandForm"));

// Land Seller
const LandSellerForm = React.lazy(
  () => import("../../Inventory/LandAndSeller/LandSeller/LandSellerForm"),
);
const LandSellerTable = React.lazy(
  () => import("../../Inventory/LandAndSeller/LandSeller/LandSellerTable"),
);

export const inventoryRoutes = [
  {
    path: "/inventory/dashboard",
    Component: InventoryDashboard,
    rolename: "ERP Inventory_Dashboard",
  },

  // Projects
  {
    path: "/inventory/projects/Projects",
    Component: ProjectTable,
    rolename: "ERP-Projects_Project",
  },
  {
    path: "/inventory/projects/Projects/add",
    Component: ProjectForm,
    rolename: "ERP-Projects_Project",
  },
  {
    path: "/inventory/projects/Projects/edit/:ProjectId",
    Component: ProjectForm,
    rolename: "ERP-Project_Create",
  },

  // Sections
  {
    path: "/inventory/projects/section",
    Component: SectionTable,
    rolename: "ERP-Projects_Section",
  },
  {
    path: "/inventory/projects/section/add",
    Component: SectionForm,
    rolename: "ERP-Projects_Section",
  },

  // Units
  {
    path: "/inventory/projects/units",
    Component: UnitTable,
    rolename: "Projects_Units",
  },
  {
    path: "/inventory/projects/units/add",
    Component: Unit,
    rolename: "Projects_Units",
  },

  // New Purchase
  {
    path: "/inventory/projects/newpurchase",
    Component: NewPurchaseTable,
    rolename: "ERP-Projects_New Purchase",
  },
  {
    path: "/inventory/projects/newpurchase/add",
    Component: NewPurchaseForm,
    rolename: "ERP-Projects_New Purchase",
  },

  // Re-Purchase
  {
    path: "/inventory/projects/repurchase",
    Component: RePurchaseTable,
    rolename: "Projects_RePuchase",
  },
  {
    path: "/inventory/projects/repurchase/add",
    Component: RePurchase,
    rolename: "Projects_RePuchase",
  },

  // Print Templates
  {
    path: "/inventory/projects/prints",
    Component: MainPrintTemplates,
    rolename: "Projects_RePuchase",
  },
  {
    path: "/inventory/projects/prints/add",
    Component: PrintTemplate,
    rolename: "Projects_RePuchase",
  },

  // Deal Bought
  {
    path: "/inventory/deals/dealbought",
    Component: DealBoughtTable,
    rolename: "Deals_Deal Bought",
  },
  {
    path: "/inventory/deals/dealbought/add",
    Component: DealBought,
    rolename: "Deals_Deal Bought",
  },

  // Deal Sold
  {
    path: "/inventory/deals/dealsold",
    Component: DealSoldMain,
    props: { type: "DealSoldTableComp" },
    rolename: "Deals_Deal Sold",
  },
  {
    path: "/inventory/deals/dealsold/add",
    Component: DealSoldMain,
    props: { type: "DealSoldComp" },
    rolename: "Deals_Deal Sold",
  },
  {
    path: "/inventory/deals/dealsold/cancel",
    Component: DealSoldMain,
    props: { type: "DealSoldCancel" },
    rolename: "Deals_Deal Sold",
  },

  // Sellers
  {
    path: "/inventory/deals/sellers",
    Component: SellerTable,
    rolename: "Deals_Seller",
  },
  {
    path: "/inventory/deals/sellers/add",
    Component: SellerForm,
    rolename: "Deals_Seller",
  },

  // Availability
  {
    path: "/inventory/availability/availability",
    Component: AvailabilityComp2,
    rolename: "Availability_Availability",
  },
  {
    path: "/inventory/availability/booked-units",
    Component: BookingUnits,
    rolename: "Availability_Booked Units",
  },

  // Land Deals
  {
    path: "/inventory/land-and-seller/land-deals",
    Component: LandDealTable,
    rolename: "Land & Seller_Land",
  },
  {
    path: "/inventory/land-and-seller/land-deals/add",
    Component: LandDealForm,
    rolename: "Land & Seller_Land",
  },

  // Land
  {
    path: "/inventory/land-and-seller/land",
    Component: LandTable,
    rolename: "Land & Seller_Land",
  },
  {
    path: "/inventory/land-and-seller/land/add",
    Component: LandForm,
    rolename: "Land & Seller_Land",
  },

  // Land Seller
  {
    path: "/inventory/land-and-seller/sellerland",
    Component: LandSellerTable,
    rolename: "Land & Seller_Land Seller",
  },
  {
    path: "/inventory/land-and-seller/sellerland/add",
    Component: LandSellerForm,
    rolename: "Land & Seller_Land Seller",
  },
];
